<template>
  <div>
      <section class="banner_area banner_contact">
            <div class="banner_inner d-flex align-items-center">
            	<div class="overlay bg-parallax" data-stellar-ratio="0.9" data-stellar-vertical-offset="0" data-background=""></div>
				<div class="container">
					<div class="banner_content text-center">
						<h2>Contato</h2>
					</div>
				</div>
            </div>
        </section>
  </div>
</template>

<script>
export default {
  name: 'BannerContact',
  props: {
    content_section: {},
  },
}
</script>

<style>

</style>